import {
  alpha,
  alphaNum,
  between,
  decimal,
  email,
  integer,
  ipAddress,
  macAddress,
  maxLength,
  maxValue,
  minLength,
  minValue,
  not,
  numeric,
  required,
  requiredIf,
  requiredUnless,
  sameAs,
  url,
  helpers
} from '@vuelidate/validators';

export const validationOptions = [
  {
    name: 'alpha',
    validation: alpha
  },
  {
    name: 'alphaNum',
    validation: alphaNum
  },
  {
    name: 'between',
    validation: between,
    additionalFields: [
      {
        label: 'Min',
        class: 'col-6',
        value: null
      },
      {
        label: 'Max',
        class: 'col-6',
        value: null
      }
    ]
  },
  {
    name: 'decimal',
    validation: decimal
  },
  {
    name: 'email',
    validation: email
  },
  {
    name: 'integer',
    validation: integer
  },
  {
    name: 'ipAddress',
    validation: ipAddress
  },
  {
    name: 'macAddress',
    validation: macAddress
  },
  {
    name: 'maxLength',
    validation: maxLength,
    additionalFields: [
      {
        label: 'Max length',
        class: 'col-12',
        value: null
      }
    ]
  },
  {
    name: 'maxValue',
    validation: maxValue,
    additionalFields: [
      {
        label: 'Max value',
        class: 'col-12',
        value: null
      }
    ]
  },
  {
    name: 'minLength',
    validation: minLength,
    additionalFields: [
      {
        label: 'Min length',
        class: 'col-12',
        value: null
      }
    ]
  },
  {
    name: 'minValue',
    validation: minValue,
    additionalFields: [
      {
        label: 'Min value',
        class: 'col-12',
        value: null
      }
    ]
  },
  {
    name: 'not',
    validation: not,
    additionalFields: [
      {
        label: 'Not',
        class: 'col-12',
        value: null
      }
    ]
  },
  {
    name: 'numeric',
    validation: numeric
  },
  {
    name: 'required',
    validation: required
  },
  {
    name: 'requiredIf',
    validation: requiredIf,
    additionalFields: [
      {
        label: 'Required if',
        class: 'col-12',
        value: null
      }
    ]
  },
  {
    name: 'requiredUnless',
    validation: requiredUnless,
    additionalFields: [
      {
        label: 'Required unless',
        class: 'col-12',
        value: null
      }
    ]
  },
  {
    name: 'sameAs',
    validation: sameAs,
    additionalFields: [
      {
        label: 'Same as',
        class: 'col-12',
        value: null
      }
    ]
  },
  {
    name: 'url',
    validation: url
  },
  {
    name: 'regex',
    validation: helpers.regex,
    additionalFields: [
      {
        label: 'Regex',
        class: 'col-12',
        value: 'new RegExp(\n\t//Insert regex here\n)',
        defaultToCode: true
      }
    ]
  },
  {
    name: 'async',
    validation: {
      $message: '',
      $params: { type: 'async' },
      $validator: null
    },
    additionalFields: [
      {
        label: 'URL',
        class: 'col-12',
        value: null
      }
    ]
  },
  {
    name: 'custom',
    validation: {
      $message: '',
      $params: { type: 'custom' },
      $validator: null
    },
    additionalFields: [
      {
        label: 'Custom',
        class: 'col-12',
        value: '(val) => {\n\t//Insert validation logic here\n}',
        defaultToCode: true
      }
    ]
  }
];
